import { Link } from "react-router-dom";
import { User, Briefcase, Users, Megaphone, ArrowRight } from "lucide-react";
import { PATHWAYS } from "../../data/config";
import { Reveal } from "../common/Reveal";

const ICONS = { user: User, briefcase: Briefcase, users: Users, megaphone: Megaphone };

export const Pathways = () => (
  <section className="py-24 lg:py-32" data-testid="pathways-section">
    <div className="container-site">
      <Reveal>
        <p className="eyebrow">Where do we begin</p>
        <h2 className="mt-4 max-w-2xl font-serif text-3xl tracking-tight text-navy sm:text-4xl lg:text-5xl">
          What are you trying to <span className="italic text-emerald">grow?</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-4">
        {PATHWAYS.map((p, i) => {
          const Icon = ICONS[p.icon];
          return (
            <Reveal key={p.id} delay={i * 0.08} className="h-full">
              <div
                className="group flex h-full flex-col bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
                data-testid={`pathway-card-${p.id}`}
              >
                <Icon className="h-6 w-6 text-gold" strokeWidth={1.25} aria-hidden="true" />
                <p className="mt-8 text-[10px] font-semibold uppercase tracking-[0.25em] text-ink/50">
                  {p.kicker}
                </p>
                <h3 className="mt-2 font-serif text-xl leading-snug text-navy">{p.title}</h3>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-ink/70">{p.description}</p>
                <Link to={p.href} className="link-arrow mt-8" data-testid={`pathway-cta-${p.id}`}>
                  {p.cta} <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
                </Link>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
